import React from 'react';
import ReactDOM from 'react-dom';

import 'whatwg-fetch';

global.Buffer = require('buffer');

import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

import Root from './components/Root';

const render = Component => ReactDOM.render(
  <Component />, document.getElementById('root'));

render(Root);


// WEBPACK FOOTER //
// ./src/index.js